import { render, staticRenderFns } from "./MultiplicationAndDivision.vue?vue&type=template&id=19fe01c8&scoped=true&lang=pug&"
import script from "./MultiplicationAndDivision.vue?vue&type=script&lang=js&"
export * from "./MultiplicationAndDivision.vue?vue&type=script&lang=js&"
import style0 from "./MultiplicationAndDivision.vue?vue&type=style&index=0&id=19fe01c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19fe01c8",
  null
  
)

export default component.exports